import React, { Component } from 'react';

import { cx } from '@emotion/css';
import * as styles from './questionWithTextFeild.style';
import QuizIndicator from './QuizIndicator';

class ImagewithTextField extends Component {
  constructor(props) {
    super(props);
    this.state = { value: this.props.selectedanswer };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({ value: event.target.value });
    this.props.selected(event.target.value, '1');
  }

  handleKeypress(e) {
    //it triggers by pressing the enter key
    if (e.charCode === 13) {
      this.props.nextbutton();
    }
  }


  selectedanswer = (answer, id) => {
    //////console.log(answer)
    // ////console.log(id)

    this.props.selected(answer, id);
  };

  render() {
    return (
      <div>
        <h2 className={cx(styles.title)}>
          <span>{this.props.questionnumber}/</span>
          {this.props.questionCount}
        </h2>

        <img className={cx(styles.imgPoster)} src={this.props.imageurl} />

        <div className={cx(styles.questions)}>{this.props.question}</div>


        <QuizIndicator
          questionCount={this.props.questionCount}
          questionnumber={this.props.questionnumber}
        />
        <div className={cx(styles.answers)}>
          <div className="s-title">Type Answer below </div>
          <div>
            <input
              id={this.props.id}
              type="text"
              spellCheck="false"
              autoComplete="off"
              value={this.state.value}
              onChange={this.handleChange}
              placeholder="Enter answer here ..."
              className={cx(styles.input)}

              onKeyPress={this.handleKeypress}
            //onChange={this.selectedanswer('name',this.props.id)}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default ImagewithTextField;
